import classNames from 'classnames';
import { motion, useScroll, useTransform } from 'framer-motion';
import React from 'react';

import { AssetStoryblok } from '../../../types/generated-storyblok';
import { Image } from '../../Image';

interface Props {
  hero?: AssetStoryblok;
  thumbnail?: string | AssetStoryblok | null;
  name: string;
}

export const ArtistHero: React.FC<Props> = ({ hero, name, thumbnail }) => {
  const { scrollY } = useScroll();
  const scale = useTransform(scrollY, [0, 480], [1, 1.1]);

  return (
    <header>
      {hero ? (
        <div className="aspect-[2/1] w-full overflow-clip rounded-md md:aspect-[3/1]">
          <motion.div style={{ scale }}>
            <Image
              alt={hero.alt || ''}
              eagerLoading
              focus={hero.focus}
              size={{
                sm: { ratio: '2/1', span: 12 },
                md: { ratio: '3/1', span: 12 },
                lg: { ratio: '3/1', span: 12 },
              }}
              src={hero.filename || ''}
            />
          </motion.div>
        </div>
      ) : null}

      <div
        className={classNames(
          'relative mx-auto flex w-full max-w-md flex-col items-center justify-start gap-y-6',
          hero ? 'pt-16' : 'pt-0',
        )}
      >
        {thumbnail ? (
          <div
            className={classNames(
              'block h-20 w-20 overflow-hidden rounded-sm',
              hero ? 'absolute -top-10 outline outline-4 outline-white' : '',
            )}
          >
            <Image
              alt={typeof thumbnail === 'string' ? name : thumbnail.alt || ''}
              eagerLoading
              focus={
                typeof thumbnail === 'string' ? undefined : thumbnail.focus
              }
              size={{
                sm: { ratio: '1/1', span: 4 },
                md: { ratio: '1/1', span: 3 },
                lg: { ratio: '1/1', span: 3 },
              }}
              src={
                typeof thumbnail === 'string' ? thumbnail : thumbnail.filename
              }
            />
          </div>
        ) : null}

        {name ? (
          <div className="flex w-full flex-col">
            <h1 className="text-balance text-center text-md font-bold md:text-lg">
              {name}
            </h1>
          </div>
        ) : null}
      </div>
    </header>
  );
};
